
import { AuthProvider } from "@/hooks/useAuth";
import { ReactNode } from "react";

interface AreaPacienteProviderProps {
  children: ReactNode;
}

export function AreaPacienteProvider({ children }: AreaPacienteProviderProps) {
  return (
    <AuthProvider>
      {children}
    </AuthProvider>
  );
}
